export default __webpack_public_path__ + "static/media/Group9226.dd26ac56.svg";